// src/components/IconImageSlider.jsx
import React from 'react';

const ImageSlider = ({ images }) => {
    // Limit to the first 4 images
    const displayImages = images.slice(0, 4);

    return (
        <div className='mt-[50px] bg-gray-100 p-5 rounded-lg shadow-md'>
            <h2 className='mb-5 md:mb-[80px] text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase'>
                Maya Devi University: Approval and Affiliation
            </h2>
            <div className='relative w-11/12 mx-auto grid grid-cols-2 md:grid-cols-4 gap-4'>
                {displayImages.map((image, index) => (
                    <div 
                        key={index} 
                        className='bg-white shadow-lg rounded-lg p-4 flex flex-col items-center transition-transform transform hover:scale-105'
                    >
                        <img 
                            src={image} 
                            className='w-[100px] h-[100px] md:w-[150px] md:h-[150px] object-cover rounded-md transition-transform transform hover:scale-110' 
                            alt={`Slide ${index + 1}`} 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageSlider;